import Hashids from "hashids"

export const decode = (slug: string, value) => {
    const hashids = new Hashids(slug)
    return hashids.decode(value)[0]
}
